// Settings -- route /settings
//
// Thin wrapper around the canonical SettingsPage from saas-common. All
// group definitions come from the server manifest (/api/admin/settings/schema);
// see internal/settings/manifest.go for the registered groups.

import { SettingsPage } from "@/admin-design/_common/settings";

export default function Settings() {
  return <SettingsPage />;
}
